import type { RecurrenceDraft } from '@/entities/recurrence';
import type { DeadlineDraft } from '@/shared/lib/deadline-draft';

import type { EventPrefill } from '@/features/calendar/CreateEventDialog';
import type { ParsedSentence } from './types';

/**
 * The form values of a reading: only what was recognised; the rest stays empty for the person.
 * A task (`deadline`) fills the DUE date and time and leaves the form in its "only a due date"
 * mode; an event fills the start and the end.
 */
export function prefillOf(id: number, parsed: ParsedSentence): EventPrefill {
  const due = parsed.kind === 'deadline';
  const form: DeadlineDraft = due
    ? {
        hasStart: false,
        startDate: '',
        startTime: '',
        endDate: parsed.startDate,
        endTime: parsed.startTime,
      }
    : {
        hasStart: true,
        startDate: parsed.startDate,
        startTime: parsed.allDay ? '' : parsed.startTime,
        // The end DATE follows the start like in any new event; no end TIME is ever invented.
        endDate: parsed.endDate || parsed.startDate,
        endTime: parsed.allDay ? '' : parsed.endTime,
      };
  const rule = parsed.recurrence;
  const repeat: RecurrenceDraft | null = rule
    ? {
        frequency: rule.frequency,
        interval: rule.interval,
        weekdays: rule.weekdays,
        startDate: parsed.startDate,
        timeOfDay: '',
        endMode: rule.untilDate ? 'date' : 'never',
        untilDate: rule.untilDate,
      }
    : null;
  return {
    id,
    title: parsed.title,
    form,
    allDay: due ? false : parsed.allDay,
    repeat,
    ...(parsed.board && { boardId: parsed.board.id }),
  };
}
